<div class="single-courses-item mb-30">
    <div class="courses-image">
        <a (click)="onRouteToDetail(course.id)" class="d-block">
            <img src="{{course.imageUrl}}" alt="image"></a>
    </div>
    <div class="courses-content">
        <div class="d-flex justify-content-between align-items-center">
            <div class="course-author d-flex align-items-center">
                
                <img *ngIf="course.teacher.avatarUrl !== '' else elseBlock" src="{{course.teacher.avatarUrl}}"
                    class="shadow" alt="image">
                <ng-template #elseBlock>
                    <img src="assets/img/teacher-placeholder.png">
                </ng-template>
                <span>{{course.teacher.nameEn}}</span>
            </div>

        </div>

        <h3><a (click)="onRouteToDetail(course.id)" class="d-inline-block">{{course.nameEn}}</a></h3>
    </div>

    <div class="courses-box-footer" *ngIf="course.createdAt">
        <ul>
            <li>
                <span><i class='bx bx-time'></i> Left days: {{ calulateDaysLeft() }}</span>
            </li>
        </ul>
    </div>
</div>